// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1OXA3","savePackageButton":"ClientWallet_savePackageButton__UJi9q"};